module.exports = __webpack_public_path__ + "img/logo.6c2ea701.svg";